var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelAd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 57,
  viewBox: "0 0 60 57",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M43.576 20.897c.752-5.704 2.366-9.647 4.236-9.647 2.59 0 4.688 7.555 4.688 16.875S50.401 45 47.813 45c-1.927 0-3.583-4.185-4.303-10.168a7.146 7.146 0 0 0 .066-13.935M2.983 36.976A2.967 2.967 0 0 1 0 34.007V21.993c0-1.653 1.348-2.98 2.999-3.002 0 0 28.719 1.007 40.886-14.294C45.532 1.73 47.512 0 49.643 0 55.363 0 60 12.472 60 27.857s-4.637 27.857-10.357 27.857c-2.614 0-5.002-2.604-6.824-6.901-6.478-6.495-16.397-9.456-24.716-10.792l4.04 15.078a1.005 1.005 0 0 1-.702 1.226l-7.736 2.073a1 1 0 0 1-1.221-.71L7.476 36.995c-2.776-.097-4.493-.02-4.493-.02"
})));
export default SvgChannelAd;